import { GrupoAlvoVacinacaoEnum, RegistroAplicado } from 'graphql/types.generated'
import { Age, calculateAge } from 'util/date/calculateAge'

import { RegistroVacinacaoFormModel, StatusDoseEnum } from './model'
import { VacinacaoRegistrosAplicadosFilterInput } from './validator'

export function getStatusDoseVacinacao(
  dataNascimento: LocalDate,
  dataAtendimento: Instant,
  diasInicioFaixaEtaria: number,
  diasFimFaixaEtaria: number,
  isAplicada: boolean
): StatusDoseEnum {
  if (isAplicada) {
    return StatusDoseEnum.APLICADA
  }

  const age = calculateAge(dataNascimento, dataAtendimento)
  const idadeAtualEmDias = ageInDays(age)

  if (idadeAtualEmDias < diasInicioFaixaEtaria) {
    return StatusDoseEnum.FUTURA
  } else if (idadeAtualEmDias > diasFimFaixaEtaria) {
    return StatusDoseEnum.ATRASADA
  }
  return StatusDoseEnum.DISPONIVEL
}

export function getGrupoAlvoVacinacao(dataNascimento: LocalDate, dataAtendimento: Instant): GrupoAlvoVacinacaoEnum {
  const idade = calculateAge(dataNascimento, dataAtendimento).years
  if (idade >= 60) {
    return GrupoAlvoVacinacaoEnum.IDOSO
  } else if (idade >= 20) {
    return GrupoAlvoVacinacaoEnum.ADULTO
  } else if (idade >= 10) {
    return GrupoAlvoVacinacaoEnum.ADOLESCENTE
  } else {
    return GrupoAlvoVacinacaoEnum.CRIANCAS
  }
}

export function getDescricaoTituloCalendario(grupoAlvo: GrupoAlvoVacinacaoEnum): string {
  switch (grupoAlvo) {
    case GrupoAlvoVacinacaoEnum.CRIANCAS:
      return ' da criança'
    case GrupoAlvoVacinacaoEnum.ADOLESCENTE:
      return ' do adolescente'
    case GrupoAlvoVacinacaoEnum.ADULTO:
      return ' do adulto'
    case GrupoAlvoVacinacaoEnum.IDOSO:
      return ' do idoso'
  }
}

export const getRegistroExistente = (
  input: VacinacaoRegistrosAplicadosFilterInput
): RegistroAplicado | RegistroVacinacaoFormModel => {
  let registro: RegistroAplicado | RegistroVacinacaoFormModel

  if (input.filterDuasListas) {
    registro =
      input.registrosAplicados.find((registro) => getFilterConditions(registro, input)) ||
      input.registrosAplicadosAtendimento.find((registro) => getFilterConditions(registro, input))
  } else {
    if (input?.registrosAplicados) {
      registro = input.registrosAplicados.find((registro) => getFilterConditions(registro, input))
    } else {
      registro = input.registrosAplicadosAtendimento.find((registro) => getFilterConditions(registro, input))
    }
  }
  return registro
}

const getFilterConditions = (registro: any, input: VacinacaoRegistrosAplicadosFilterInput) => {
  if (registro?.imunobiologicoId) {
    if (input.imunobiologicoId !== registro.imunobiologicoId) return false
  } else {
    if (input.imunobiologicoId !== registro?.outrosImunosImunobiologico?.id) return false
  }

  if (!!input.doseId) {
    if (registro.doseId) {
      if (input?.doseId !== registro.doseId) return false
    } else {
      if (input.doseId !== registro?.outrosImunosDose?.id) return false
    }
  }

  if (isRegistroVacinacaoFormModel(registro)) {
    if (!!input.tipoRegistro && input.tipoRegistro !== registro.tipoRegistroVacinacao) return false

    if (!!registro.isRegistroAnterior !== !!input?.isRegistroAnterior) return false

    if (!!input.idUnicoRegistro && registro.idUnicoRegistro !== undefined) return false
  } else {
    if (!!input.isAprazamento && !input.isAprazamento && !!registro.dataAprazamento) return false
  }

  return true
}

export function ageInDays(age: Age) {
  const daysInMonth = 31
  return age.years * (12 * daysInMonth) + age.months * daysInMonth + age.days
}

const isRegistroVacinacaoFormModel = (registro: any): registro is RegistroVacinacaoFormModel =>
  registro.dataRegistro !== undefined
